import React from "react";
import Header from "../../layoutUser/header/header";
import Sidebar from "../../layoutUser/sidebar/sidebar";
import Center from "../../layoutUser/center/home";
import useMediaQuery from "@mui/material/useMediaQuery";
import "../../assets/styles/styleUser.css";
function HomeUser(props) {
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  return (
    <div className="container">
      <Header placeholder={'Search place...'} isHomePage={true} />
      {
        isSmallScreen?null: <Sidebar />
      }
     
      <Center />
    </div>
  );
}

export default HomeUser;
